var exports = {
  "g4": "InviteModal.module__loadingContainer___MUJkbz",
  "qy": "InviteModal.module__channelSubtitle___MUJkbz",
  "HA": "InviteModal.module__channelName___MUJkbz",
  "p": "InviteModal.module__channelIcon___MUJkbz",
  "ak": "InviteModal.module__inviteButton___MUJkbz",
  "UW": "InviteModal.module__warningContainer___MUJkbz",
  "QW": "InviteModal.module__warningIcon___MUJkbz",
  "i4": "InviteModal.module__warningText___MUJkbz",
  "xr": "InviteModal.module__expirationText___MUJkbz",
  "bv": "InviteModal.module__editLink___MUJkbz",
  "Wm": "InviteModal.module__detailedView___MUJkbz",
  "WT": "InviteModal.module__noChannelContent___MUJkbz",
  "Q9": "InviteModal.module__noChannelIcon___MUJkbz",
  "E_": "InviteModal.module__noChannelText___MUJkbz",
};

module.exports = exports;
